import React from "react";
import PropTypes from "prop-types";

import { differenceInCalendarDays, format, parseISO } from "date-fns";
import { Header } from "semantic-ui-react";

export function TileStartDate({ date, sinceDate = new Date() }) {
  const formattedStartDate = () => {
    try {
      const today = () => {
        return sinceDate || new Date();
      };
      const targetDate = parseISO(date);
      const daysPassed = differenceInCalendarDays(today(), targetDate);

      if (daysPassed < 0) return "Date cannot be in the future";
      if (daysPassed === 0) return "Started: Today";
      if (daysPassed === 1) return "Started: Yesterday";

      return `Started: ${format(targetDate, "MMM dd, yyyy")}${
        daysPassed < 100 ? ` (${daysPassed} days)` : ""
      }`;
    } catch (e) {
      console.error(e);
      return "Error in retrieving start date";
    }
  };

  return (
    <Header
      data-test="client-tile-started-header"
      style={{
        color: "grey",
        fontSize: "14px",
        fontWeight: "500",
      }}
    >
      {formattedStartDate()}
    </Header>
  );
}

export default TileStartDate;

TileStartDate.propTypes = {
  date: PropTypes.string.isRequired,
  sinceDate: PropTypes.instanceOf(Date),
};

TileStartDate.defaultProps = {
  sinceDate: new Date(),
};
